/**
 * This file is auto-generated from MainHeader.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const healedHomepage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed homepage';
        case 'pl':
            return 'Strona główna Healed';
    }
};

export const mainNavigation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Main menu';
        case 'pl':
            return 'Menu główne';
    }
};

export const mainPage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Main page';
        case 'pl':
            return 'Strona główna';
    }
};

export const chats: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Chats';
        case 'pl':
            return 'Czaty';
    }
};

export const yourProfile: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Your profile';
        case 'pl':
            return 'Twój profil';
    }
};

export const startNewChat: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Start new chat';
        case 'pl':
            return 'Rozpocznij nowy czat';
    }
};

export const logIn: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Log in';
        case 'pl':
            return 'Zaloguj się';
    }
};

export const logOut: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Log out';
        case 'pl':
            return 'Wyloguj się';
    }
};

export const openMenu: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Open menu';
        case 'pl':
            return 'Otwórz menu';
    }
};

export const closeMenu: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Close menu';
        case 'pl':
            return 'Zamknij menu';
    }
};
